/* eslint-disable no-irregular-whitespace */
export default {
  title: "智绘网络用户服务协议",
  content: `<h3 class="sub-title">1. 导言</h3>
    <p>
        为更好地向智绘网络用户提供服务，亦为规范智绘网络用户的行为，用户应当阅读并遵守《智绘网络用户服务协议》（以下简称“本协议”）。
    </p>
    <p>
        本协议为《智绘网络服务协议》修订版，自本协议生效之日起，除另有明确约定外，智绘网络平台各处所推出的新产品、新功能和新服务，均无条件的适用本协议。
    </p>
    <p style="font-weight:bold">《智绘网络用户服务协议》正文</p>
    <h3 class="sub-title">2. 定义</h3>
    <p>
        2.1 相关定义：
    </p>
    <p>
        2.1.1 本协议是指用户与长春市智绘网络科技有限公司（以下简称“智绘网络”）及其相关服务可能存在的合作公司之间，关于使用智绘网络平台的所有服务所订立的协议；
    </p>
    <p>
        2.1.2 “用户”是指使用本协议下相关服务的拥有完全民事行为能力的自然人或法人，在本协议中更多地称为“您”；<strong>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并且在使用智绘网络的服务前，事先取得您家长或法定监护人（以下统称"监护人"）的同意；</strong>
    </p>
    <p>
        2.1.3 智绘网络平台是指智绘网络旗下的域名为hhzh.net等网站以及客户端。如无特别说明，则本协议中将合并称为智绘网络平台；
    </p>
    <p>
        2.1.4 智绘网络平台的所有服务是指，智绘网络基于互联网，以包含智绘网络平台网站、客户端、APP等在内的各种形式（包括未来技术发展出现的新的服务形态）向您所提供的各项服务，包括但不限于平台账号的注册、使用与管理等平台账号相关服务、域名注册、域名交易、域名转移、域名续费等以及商标、专利、版权等知识产权服务。
    </p>
    <p>
        2.2 为了保护网络信息安全，保障公民、法人和其他组织的合法权益，维护国家安全和社会公共利益。根据《中华人民共和国合同法》等其他相关各项法律法规的规定，智绘网络制定并按照本协议提供网络服务。
    </p>
    <p>
        2.3 智绘网络有权在必要时修改本协议条款，且无需另行通知，您可以在对应的服务页面查阅最新版本的协议条款。
    </p>
    <h3 class="sub-title">3. 协议的订立、生效、更新和适用范围</h3>
    <p>
        3.1 用户通过在智绘网络平台确认本协议或以其他方式确认本协议，包括不限于未点击确认本协议而使用了智绘网络服务的，均表示用户与智绘网络及其合作公司已就本协议达成一致并同意接受本协议的全部约定内容。
    </p>
    <p>
        3.2 本协议自用户确认本协议之时即刻生效。如用户未点击确认本协议，但事实上已经在使用智绘网络服务或履行本协议，则本协议会在用户的事实行为首次发生之时即生效。
    </p>
    <p>
        3.3 智绘网络可根据国家法律法规变化及维护交易秩序、保护消费者权益的需要，不时修改本协议、补充协议、平台规则等。变更后的协议、补充协议、规则（下称“变更事项”），如您不同意的，您有权于变更事项确定的生效日前联系智绘网络反馈意见。如反馈意见得以采纳，智绘网络将酌情调整变更事项；<strong>
            如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用智绘网络平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用智绘网络平台服务，则视为您同意已生效的变更事项。
        </strong>
    </p>
    <p>
        3.4 本协议包括本协议正文及所有智绘网络已经发布或将来可能发布的关于智绘网络平台所有服务的各类规则、规范、通知和公告等（以下合称“规则”），所有规则为本协议不可分割的组成部分，与本协议正文具有同等法律效力。
    </p>
    <h3 class="sub-title">
        4. 服务项目及风险须知
    </h3>
    <p>
        4.1 您理解并悉知：任何服务项目能否成功都存在风险。
    </p>
    <p>
        4.2 您理解并同意：服务费用根据您选择的服务项目的内容进行收费，如您有超出所选择的服务项目范围的需求，您可以按照智绘网络平台规则另行购买相应服务。
    </p>
    <p>
        4.3 您理解并同意：智绘网络有权根据公司发展情况和政策变化等原因，对各项服务项目收费标准进行调整。具体价格请以各项服务的页面标示为准。
    </p>
    <p>
        4.4 您理解并悉知：某些服务内容对时效性有一定的要求。您确认购买本协议下相关服务后，须按照相应法律法规的规定以及智绘网络要求的时间内积极配合智绘网络以便智绘网络能更好地为您提供服务，以满足您的需求；否则，智绘网络及其合作公司不承担任何责任。 
    </p>
    <p>
        <strong>4.5 您理解并悉知：为了更好地为您提供服务，您需要按照智绘网络的要求提供相应的资料，并且您需要对您所提供的一切资料的真实性、合法性、完整性负责，否则因资料问题产生的一切后果由您自行承担。</strong> 
    </p>
    <h3 class="sub-title">5. 费用与支付</h3>
    <p>
        5.1 您理解并同意：本协议下的某些服务为有偿服务，您应为您所购买的服务支付费用，并承担服务过程中所产生的其他相关费用。 
    </p>
    <p>
        5.2 您理解并同意：根据您选择的服务类型不同，相应的收费标准也不同，具体费用以您实际具体所选择的的服务为准，同时应以智绘网络最终通知的收费价格为准。
    </p>
    <p>
        <strong>5.3 您理解并同意：智绘网络可能根据实际需要对收费服务的收费标准、方式进行修改和变更；智绘网络也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，智绘网络将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务；如果您发生付费或使用智绘网络服务任何一项行为即表示您已经明确同意接受智绘网络的收费标准。</strong>
    </p>
    <p>
        5.4 关于您账号下的款项，您需要理解并同意以下事宜：
    </p>
    <p>
        5.4.1 您可以通过付款页面上的提示选择付款方式。若您选择充值到您在智绘网络平台的账号下，则属于您自愿存入，账号下的款项提现须按照智绘网络平台的提现规则办理；
    </p>
    <p>
        5.4.2 若您的账号余额不足以支付当前服务款项的，您将不能办理除交费以外的其他业务。
    </p>
    <p><strong>5.5 您需要理解并同意：若您选择了智绘网络的有偿服务，您需要按照本协议或相关规则支付费用。若您未按规定缴纳相应费用的，智绘网络有权终止提供服务并终止您账号的相关权利，并且在任何情况下，对任何间接、偶然、特殊及继起的损害不负责任。</strong></p>
    <p>5.6 在使用智绘网络服务过程中，您需要理解并同意以下事宜：</p>
    <p>5.6.1 您所购买的服务将由智绘网络或其合作公司提供，您的款项将由智绘网络或其合作公司收取；</p>
    <p>5.6.2 您为相关服务所支出的费用，如需发票也是由智绘网络或其合作公司开具。</p>
    <h3 class="sub-title">6. 用户的权利与义务</h3>
    <p>6.1 在使用智绘网络所有服务过程中，您承诺遵守以下约定：</p>
    <p>6.1.1 您实施所有的行为均遵守国家法律、法规等规范性文件、本协议约定和智绘网络各项规则和规定的要求，不违背社会公共利益或公共道德，不损害他人的合法权益。如您违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并承担因此给智绘网络及其合作公司、其他第三方造成的损失；</p>
    <p>6.1.2 只通过正当手段使用智绘网络的所有服务，产生有效的显示、点击、交易以及其他智绘网络及其合作公司认可的数据，不采用任何欺骗或虚假性质的行为；</p>
    <p>6.1.3 不对智绘网络的任何数据作商业性利用，包括但不限于在未经智绘网络事先书面同意的情况下，以复制、传播等任何方式使用智绘网络网站、提供智绘网络服务的其他平台上展示的资料。未经智绘网络事先书面同意，不向任何第三方提供从智绘网络获取的任何数据，智绘网络已公开的数据除外；</p>
    <p>6.1.4 不使用任何装置、软件或例行程序干预或试图干预智绘网络平台、提供智绘网络服务的其他平台的正常运作。不得采取任何导致不合理的庞大数据负载加诸智绘网络平台或提供智绘网络平台服务的其他平台网络设备的行动。</p>
    <p>6.2 注册成为智绘网络平台用户的，必须是具有完全民事行为能力的自然人，或者是有合法经营、存续资格的法人或其他非法人组织。若您不具备前述主体资格，则您及您的监护人应承担因此而产生的一切法律责任。</p>
    <p>6.3 您理解并悉知：用户注册是指用户登陆智绘网络网站，按要求填写相关信息并确认同意本协议的过程，用户因进行交易、获取有偿服务等发生的所有应纳税赋以及一切硬件、软件、服务及其它方面的费用，均由您自行承担。</p>
    <p>6.4 您有义务在注册成为智绘网络平台用户并获得本协议下所有服务时提供自己的真实资料，并保证诸如姓名、有效证件号码（身份证、公司注册证、军官证、护照等）、电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及真实性，保证智绘网络及其合作公司可以通过上述联系方式与您本人进行联系、送达相关文件，如上述联系方式有变更，您应第一时间告知智绘网络。如果因注册信息不真实而引起的相关问题，并由此产生的一切后果及责任，均由您承担，智绘网络及其合作公司不承担任何责任。</p>
    <p><strong>6.5 您的账号注册成功后，可以根据智绘网络规定改变密码，您应谨慎合理的保存、使用账号名和密码。包括但不限于因以下用户自身问题导致信息外泄，智绘网络不承担任何责任：</strong></p>
    <p><strong>6.5.1 设置的密码过于简单；</strong></p>
    <p><strong>6.5.2 在其他平台使用相同密码，其他平台被暴库或密码破解，而导致密码泄露；</strong></p>
    <p><strong>6.5.3 自身手机或证件保管不善导致信息泄露；</strong></p>
    <p><strong>6.5.4 其他非智绘网络原因导致的信息外泄。</strong></p>
    <p>6.6 您理解并同意：您应按照智绘网络的要求在智绘网络平台完成用户信息完善且通过验证等操作。在您成为智绘网络用户后，如您对已通过验证的用户信息进行调整等并导致其不符合智绘网络要求的，由您自行负责。</p>
    <p>6.7 您理解并同意：智绘网络提供了多种账号安全验证措施，您可以根据自己的意愿进行设置，凡使用密码或通过安全保护措施验证办理的业务，智绘网络均视为您本人办理。</p>
    <p><strong>6.8 若您发现任何非法使用您账号或存在安全漏洞的情况，请立即向公安机关报案，智绘网络在接到公安机关受理回执后，有义务协助公安机关进行调查取证。</strong></p>
    <p><strong>6.9 您理解并同意：您有义务保障使用智绘网络服务的时候处于安全的网络环境下，由于网络环境安全所导致的损失，智绘网络不承担任何责任。</strong></p>
    <p><strong>6.10 您理解并保证：不将账号、密码转让或出借予他人使用。如用户发现其账号遭他人非法使用，应立即通知智绘网络。因黑客行为或用户的保管疏忽导致账号、密码遭他人非法使用，智绘网络不承担任何责任。</strong></p>
    <p>6.11 智绘网络提供账号注销服务，如需注销注册的账号，可联系智绘网络客户服务中心进行办理；</p>
    <p>6.12 您理解并同意：在使用智绘网络服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不利用智绘网络提供的服务进行违反国家法律法规政策的活动，或发表不当言论和任何形式的广告。 </p>
    <p>6.13 您理解并同意：智绘网络及其合作公司有权在您违反上述任何约定时有权注销或冻结您的账号并终止向您提供服务，因您违约或不当行为给智绘网络及其合作公司造成损失的，您应予赔偿。</p>
    <p><strong>6.14 您理解并同意：您必须出于合法、正当的目的使用或选择购买本协议下的所有服务，如智绘网络在按照您的选择和要求为您提供服务或由于您自身的原因，而引起的经济纠纷、商务纠纷或违法事件等全部由您自行承担责任，给智绘网络及其合作公司造成损失的也应予以赔偿。</strong></p>
    <h3 class="sub-title">7. 智绘网络的权利与义务</h3>
    <p>7.1 智绘网络有义务在现有技术上维护智绘网络平台的正常运行，并努力提升和改进技术使用户顺利获得所购买的服务。</p>
    <p>7.2 智绘网络及其合作公司将积极维护您的合法权益，不随意更改服务事项。</p>
    <p>7.3 智绘网络及其合作公司有义务对您的个人信息以及相关资料保密。</p>
    <p>7.4 对用户在注册和使用智绘网络网上交易平台中所遇到的与注册、交易有关的问题及反映情况，智绘网络应协助处理并作出答复。</p>
    <p><strong>7.5 智绘网络有权在发现您出现违反本协议或法律法规规定的行为时采取一定的措施消除影响，包括但不限于冻结账号、资金、取消交易、注销域名等，并不负事先通知的义务。</strong></p>
    <p>7.6智绘网络及其合作公司对您所作出的任何通知，不论是口头的还是书面的，均不构成超出本协议陈述以外的任何承诺，所有通知均应按照本协议的文本进行解释。</p>
    <p>7.7如经国家行政或司法机关的生效法律文件确认用户存在违法或侵权行为，则智绘网络及其合作公司有权按照本协议约定进行处理并采取必要的措施。</p>
    <p><strong>7.8 在所适用的法律允许范围内，智绘网络不做任何明示或默认的声明，也不给予任何明示或默认的保证或承诺，包括但不限于：</strong></p>
    <p><strong>7.8.1 关于特定用途适用性、准确性和无侵权行为的任何保证或承诺；</strong></p>
    <p><strong>7.8.2 在知识产权交易过程或行业惯例中产生的任何保证或承诺；</strong></p>
    <p><strong>7.8.3 在使用智绘网络服务时不受任何干扰、没有错误的任何保证或承诺。</strong></p>
    <p><strong>7.9 智绘网络不对源于、基于或因本协议或使用智绘网络服务而导致的数据丢失或任何损害承担赔偿责任，包括但不限于直接的、间接的、特殊的、附带的或惩罚性的损害赔偿或其他任何形式的损害赔偿，即使智绘网络已被告知此等损害赔偿的可能性。</strong></p>
    <p><strong>7.10 如您违反有关法律法规或本协议之规定，使智绘网络遭受任何损失，或受到任何第三方索赔，或受到任何行政管理部门的处罚，您应赔偿智绘网络因此遭受的全部损失。</strong></p>
    <h3 class="sub-title">8. 服务使用、变更、中断或终止</h3>
    <p><strong>8.1 智绘网络及其合作公司为您提供的各项服务，您应正当、合理、善意地使用。如发生下列任何一种情形，智绘网络及其合作公司有权不经通知而中断或终止向您提供的服务：</strong></p>
    <p><strong>8.1.1 提供的个人资料不真实、或与注册时信息不一致又未能提供合理说明；  </strong></p>
    <p><strong>8.1.2 违反相关法律法规的规定或本协议的约定；</strong></p>
    <p><strong>8.1.3 按照法律规定或主管部门的要求；  </strong></p>
    <p><strong>8.1.4 出于安全的原因或其他必要的情形 。</strong></p>
    <p><strong>8.2 如因系统维护或升级的需要而需暂停网络服务，智绘网络将尽可能事先进行通知，但由于不可预计的、临时性的、不可抗拒的调整维护或升级导致需要暂停网络服务的，智绘网络及其合作公司不承担任何责任。</strong></p>
    <p><strong>8.3 您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，智绘网络及其合作公司不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：  </strong></p>
    <p><strong>8.3.1 来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</strong></p>
    <p><strong>8.3.2 因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失； </strong></p>
    <p><strong>8.3.3 其他因网络信息或用户行为引起的风险。</strong></p>
    <p><strong>8.4 您理解并同意：本协议下的所有服务并非为某些特定目的（包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域）而设计，如果因为软件或服务的原因导致您无法达成前述特定目的而导致的人员伤亡、财产损失和环境破坏等后果，智绘网络及其合作公司不承担任何责任。</strong></p>
    <p><strong>8.5 智绘网络及其合作公司依据本协议约定获得处理违法违规内容的权利，该权利不构成智绘网络及其合作公司的义务或承诺，智绘网络及其合作公司不能保证及时发现违法行为或进行相应处理。</strong></p>
    <p><strong>8.6 您理解并同意：存在如下情形时，智绘网络有权对您名下账号暂停或终止提供全部或部分服务，或对您的操作暂停或撤销（包括或不限于已完成或未完成的操作）：</strong></p>
    <p><strong>8.6.1 根据本协议的约定可以暂停或终止的情况；</strong></p>
    <p><strong>8.6.2 根据法律法规及法律文书的规定要求暂停或终止的情况；</strong></p>
    <p><strong>8.6.3 根据有权机关的要求；</strong></p>
    <p><strong>8.6.4 您使用智绘网络服务的行为涉嫌违反国家法律法规及行政规定的；</strong></p>
    <p><strong>8.6.5 智绘网络基于单方面合理判断认为账号操作或资金进出等存在异常时；</strong></p>
    <p><strong>8.6.6 智绘网络依据自行合理判断认为可能产生风险的；</strong></p>
    <p><strong>8.6.7 您有批量注册账号、刷信用及其他舞弊等违反活动规则、违反诚实信用原则的；</strong></p>
    <p><strong>8.6.8 他人向您账号错误汇入资金等导致您可能存在不当得利的；</strong></p>
    <p><strong>8.6.9 您遭到他人投诉，且对方已经提供了一定证据的；</strong></p>
    <p><strong>8.6.10 您可能错误地将他人账号进行了实名制或实名认证的。</strong></p>
    <p><strong>8.7 智绘网络发现用户出现上述行为后，有权不事先通知您就根据自主判断采取如下之一或多项措施消除影响，并不负违约责任：</strong></p>
    <p><strong>8.7.1 中断您与智绘网络的各项服务或单项服务的连接，并限制您访问；</strong></p>
    <p><strong>8.7.2 冻结您的ID账号、款项或信息发布的权利；</strong></p>
    <p><strong>8.7.3 屏蔽您使用的IP；</strong></p>
    <p><strong>8.7.4 其他能够消除影响的措施。</strong></p>
    <h3 class="sub-title">9. 不可抗力及免责条款</h3>
    <p><strong>9.1 智绘网络及其合作公司服务将按“现状”的状态提供。智绘网络及其合作公司在此明确声明对智绘网络及其合作公司的服务不作任何明示或暗示的保证，包括但不限于智绘网络及其合作公司服务的可适用性、没有错误或疏漏、持续性、安全性、准确性、可靠性、适用于某一特定用途等。</strong></p>
    <p><strong>9.2 您理解并同意：智绘网络及其合作公司不能保证其所提供的服务毫无瑕疵，也无法随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。所以您也同意：即使智绘网络及其合作公司提供的服务存在瑕疵，但上述瑕疵是当时行业技术水平所无法避免的，其将不被视为智绘网络及其合作公司违约，同时，由此给您造成的数据或信息丢失等损失的，智绘网络及其合作公司不承担任何责任。</strong></p>
    <p><strong>9.3 您理解并同意：鉴于网络服务的特殊性，智绘网络有权在无需通知您的情况下根据智绘网络开放平台的整体运营情况或相关运营规范、规则等，可以随时变更、中止或终止部分或全部的服务，智绘网络无需对您或第三方承担责任。</strong></p>
    <p><strong>9.4 您理解并同意：为了向您提供更完善的服务，智绘网络有权定期或不定期地对提供本服务的平台或相关设备进行检修、维护、升级等，如因此造成智绘网络及其合作公司服务在合理时间内中断或暂停的，智绘网络及其合作公司无需为此承担任何责任。</strong></p>
    <p><strong>9.5 您理解并同意：若由于对以下情形导致的服务中断或受阻，给您造成损失的，智绘网络及其合作公司无需为此担任何责任：</strong></p>
    <p><strong>9.5.1 第三方未经批准使用用户账号或更改用户的数据；</strong></p>
    <p><strong>9.5.2 用户对智绘网络及其合作公司服务的误解或用户本身操作错误导致的损失；</strong></p>
    <p><strong>9.5.3 因智绘网络及其合作公司合理范围控制以外的原因，包括但不限于由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯及其他系统的故障，电力故障、自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足，战争、动乱、政府行为等。  </strong></p>
    <p><strong>9.6 在任何情况下，您均不应轻信借款、索要密码或其他涉及财产的网络信息；涉及财产操作的，请一定先核实对方身份，并请经常留意智绘网络有关防范诈骗犯罪的提示。</strong></p>
    <p><strong>9.7 您理解并与智绘网络共同在此认可：在任何情况下，如您在使用本服务过程中因智绘网络违约原因造成您损失的，智绘网络的违约赔偿总额不超过您已经支付的相应违约服务对应的服务费总额。</strong></p>
    <h3 class="sub-title">10. 未成年人使用条款</h3>
    <p>10.1 若您未满18周岁，则为未成年人，应在监护人监护</p>
    <p>10.2 未成年人用户在使用本服务时应注意以下事项，提高</p>
    <p>10.2.1 认清网络世界与现实世界的区别，避免沉迷于网络</p>
    <p>10.2.2 填写个人资料时，加强个人保护意识，以免不良分</p>
    <p>10.2.3 在监护人或老师的指导下，学习正确使用网络；</p>
    <p>10.2.4 避免陌生网友随意会面或参与联谊活动，以免不法</p>
    <p>10.3 监护人、学校均应对未成年人使用本服务时多做引导沟通，指导子女上网应该注意的安全问题，防患于未然。</p>
    <h3 class="sub-title">11. 知识产权声明</h3>
    <p>11.1 智绘网络在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归智绘网络所有，您在使用本服务中所产生的内容的知识产权归您或相关权利人所有。</p>
    <p>11.2 除另有特别声明外，智绘网络提供本服务时所依托软件的商标权、著作权、专利权及其他知识产权均归智绘网络所有。</p>
    <p>11.3 智绘网络在本服务中所使用的商业标识，其著作权或商标权归智绘网络所有。</p>
    <p>11.4 上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经智绘网络、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>
    <h3 class="sub-title">12. 管辖及法律适用</h3>
    <p><strong>12.1 本协议签订地为中华人民共和国吉林省长春市绿园区。</strong></p>
    <p><strong>12.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。如无相关法律规定的，则应参照通用国内行业惯例。</strong></p>
    <p><strong>12.3 若您和智绘网络及其合作公司之间发生任何纠纷或争议，首先应友好协商解决。协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</strong></p>
    <p><strong>12.4 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</strong></p>
    <p><strong>12.5 本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性，其余条款对双方仍具有约束力。</strong></p>
    <h3 class="sub-title">13. 附则</h3>
    <p>13.1 本协议内容包括以上条款及智绘网络已经发布的或将来可能发布的各类协议，视为本协议不可分割的一部分，具有同等法律效力。在您使用该服务时，已经阅读、理解并接受本协议的全部条款及各类规则，并承诺遵守中国的各类法律规定，如有违反而导致任何法律责任，您将以自己的名义独立承担相应的法律责任。</p>`,
};
